export const ModalCode = {
    Login: 'Login',
    Register: 'Register',
    SearchPlayer: 'SearchPlayer',
    Onboarding: 'Onboarding',
    PwaInstall: 'PwaInstall',
    AdminList: 'AdminList',
    ResetPassword: 'ResetPassword',
    MessagePlayers: 'MessagePlayers',
    ConfirmDelete: 'ConfirmDelete',
    SetTheme: 'SetTheme',
    InsertLinkModal: 'InsertLinkModal',
    BecomeMember: 'BecomeMember',
    EndMembership: 'EndMembership',
    UpdateMembershipStart: 'UpdateMembershipStart',
    AdjustMembershipType: 'AdjustMembershipType',
    GmTermsAndConditions: 'GmTermsAndConditions',
    AwardBadge: 'AwardBadge',
    RemoveBadge: 'RemoveBadge',
    BadgeInfo: 'BadgeInfo',
    StreakInfo: 'StreakInfo',
    AnalyticsConsent: 'AnalyticsConsent',
} as const;

export type ModalCode = (typeof ModalCode)[keyof typeof ModalCode];
